
<div class="card">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-sm-10">
        <p class="text-muted text-uppercase fw-semibold">TK Availability</p>
      </div>
      <div class="col-sm-1" style="top: -2%;width: 2%;">
        @if (isLoading) {
          <span class="pageLoader">
            <div class="loading-spinner"></div>
          </span>
        }
      </div>
      <div class="col-sm-2" style="display: inline-block;width: 14%;padding-right: 0px;">
        <span style="float: right;"><p-calendar [(ngModel)]="date" [showTransitionOptions]="'1ms'"
        (onSelect)="onAvailabilityChange($event)" [showIcon]="true"></p-calendar></span>
      </div>
    </div>

    <div class="app-calendar">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>